function round6(x: number): number {
  return Math.round(x * 1e6);
}

export function coordKey(lng: number, lat: number): string {
  if (!Number.isFinite(lng) || !Number.isFinite(lat)) return "";
  return `${round6(lng)},${round6(lat)}`;
}

export function lookupCoord(map: Map<string, string>, lng: number, lat: number): string | undefined {
  if (!Number.isFinite(lng) || !Number.isFinite(lat)) return undefined;
  const baseLng = round6(lng);
  const baseLat = round6(lat);
  const exact = map.get(`${baseLng},${baseLat}`);
  if (exact !== undefined) return exact;
  for (let dx = -1; dx <= 1; dx++) {
    for (let dy = -1; dy <= 1; dy++) {
      if (dx === 0 && dy === 0) continue;
      const v = map.get(`${baseLng + dx},${baseLat + dy}`);
      if (v !== undefined) return v;
    }
  }
  return undefined;
}

export interface LabeledPlace {
  id: string;
  lat: number;
  lng: number;
}

export function parseLabeledPlaces(text: string): LabeledPlace[] {
  const data = JSON.parse(text) as { features?: unknown[] };
  const features = Array.isArray(data?.features) ? data.features : [];
  const out: LabeledPlace[] = [];
  for (const f of features) {
    const feature = f as { properties?: { name?: unknown }; geometry?: { coordinates?: unknown[] } };
    const id = String(feature?.properties?.name ?? "").trim();
    const coords = feature?.geometry?.coordinates;
    if (!id || !Array.isArray(coords) || coords.length < 2) continue;
    const lng = Number(coords[0]);
    const lat = Number(coords[1]);
    if (!Number.isFinite(lng) || !Number.isFinite(lat)) continue;
    out.push({ id, lat, lng });
  }
  return out;
}

export function buildCoordIndex(entries: LabeledPlace[]): Map<string, string> {
  const map = new Map<string, string>();
  for (const e of entries) {
    const k = coordKey(e.lng, e.lat);
    if (k) map.set(k, e.id);
  }
  return map;
}
